
import React from 'react';
import { Handle, Position } from '@xyflow/react';

interface NodeHandleProps {
  type: 'source' | 'target';
  position: Position;
  nodeId: string;
}

export const NodeHandle: React.FC<NodeHandleProps> = ({ type, position, nodeId }) => {
  return (
    <Handle
      type={type}
      position={position}
      id={`${nodeId}-${type}-${position}`}
      className="w-3 h-3 rounded-full border-2 border-gray-400"
    />
  );
};
